import requireAll from "./global/scripts/misc/requireAll";

// Main styles
import './global/styles/global_styles/global_styles.scss';

// Main scripts
import './global/scripts/behaviour';
import './global/scripts/misc/scrolled';
import './global/scripts/misc/browserFeatures';
import './global/scripts/misc/nonGutenbergPages';

// Css variables
requireAll(require.context("./global/styles/variables/css/", true));

// Fonts
import './global/fonts/icons/iconfont.css';
import './global/fonts/lufga/stylesheet.css';
import './global/fonts/biosans/stylesheet.css';

// Atomic elements (JS & SCSS)
requireAll(require.context("./elements", true, /^(?!.*_.*).*\.(scss|js)$/));

// Styleguide elements (JS & SCSS)
requireAll(require.context("./docs", true, /^(?!.*_.*).*\.(scss|js)$/));
